import {fetchAndParse} from "#lib/helpers/fetch.js";
import {useAuthQuery} from "#lib/hooks/use-query.js";

export function useDepositi(isGiacenze, filter = '') {
    const endpoint = isGiacenze? 'depositi/giacenza' : 'depositi';
    const {data, ...queryProps} = useAuthQuery({
        queryKey: ['depositi'],
        staleTime: 'Infinity',
        refetchOnWindowFocus: false,
        retry: false,
        retryOnMount: false,
        queryFn: (_, headers) =>
            fetchAndParse(`${API_URL}/p/${endpoint}?filter=${filter}`, {
                headers
            })
    });

    return {data: data?.results, ...queryProps};
}